/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */

import * as Services from '@services';
import { ServiceGroup } from '@services';
import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';

class ServiceGroupStore {
  serviceGroups: Services.PagedResultDto<Services.ServiceGroup> = {
    totalCount: 0,
    items: [],
  };
  serviceGroup!: Services.ServiceGroup | undefined;
  loading = false;
  selectServiceGroups: Map<number, ServiceGroup> = new Map();
  selectLoading = false;
  selectSkipCount = 0;
  selectPageSize = 10;
  selectTotalCount = 0;
  selectScroll = false;

  constructor() {
    makeAutoObservable(this);
  }

  setServiceGroupLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  async getAll(request: Services.PagedServiceGroupRequest) {
    const result = await Services.ServiceGroupService.getAll(request);
    runInAction(() => {
      this.serviceGroups = result;
    });
  }

  async getSelectServiceGroups(request: Services.PagedServiceGroupRequest) {
    this.setSelectLoading(true);

    //handles search with scroll
    if (request.keyword && !this.selectScroll) {
      request.skipCount = 0;
      this.clearSelectServiceGroups();
      this.setSelectSkipCount(0);
      this.setSelectScroll(true);
    }

    //handles clear
    if (!request.keyword && this.selectScroll) {
      request.skipCount = 0;
      this.clearSelectServiceGroups();
      this.setSelectSkipCount(0);
      this.setSelectScroll(false);
    }

    const result = await Services.ServiceGroupService.getAll(request);

    runInAction(() => {
      result.items.forEach((serviceGroup: ServiceGroup) => {
        this.selectServiceGroups.set(serviceGroup.id, serviceGroup);
      });

      this.selectTotalCount = result.totalCount;
      this.selectLoading = false;
    });
  }

  async get(entityDto: Services.EntityDto) {
    this.setServiceGroupLoading(true);
    try {
      const result = await Services.ServiceGroupService.get(entityDto);
      runInAction(() => {
        this.serviceGroup = result;
      });
      this.setServiceGroupLoading(false);
    } catch (error) {
      this.setServiceGroupLoading(false);
      console.log(error);
    }
  }

  async create(serviceGroup: Services.ServiceGroup) {
    this.setServiceGroupLoading(true);
    try {
      const result = await Services.ServiceGroupService.create(serviceGroup);
      runInAction(() => {
        this.selectServiceGroups.set(result.id, result);
        this.serviceGroups.items = [...this.serviceGroups.items, result];
        this.serviceGroups.totalCount += 1;
      });
      message.success({
        content: 'Successfully created!',
      });
      this.setServiceGroupLoading(false);
      return result;
    } catch (error) {
      this.setServiceGroupLoading(false);
      return null;
    }
  }

  async update(serviceGroup: Services.ServiceGroup) {
    try {
      const result = await Services.ServiceGroupService.update(serviceGroup);
      runInAction(() => {
        this.serviceGroup = result;
      });
      message.success({ content: 'Successfully updated!' });
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  setSelectLoading = (value: boolean) => {
    runInAction(() => {
      this.selectLoading = value;
    });
  };

  clearServiceGroup = () => {
    runInAction(() => {
      this.serviceGroup = undefined;
    });
  };

  clearSelectServiceGroups = () => {
    runInAction(() => {
      this.selectServiceGroups.clear();
      this.selectTotalCount = 0;
    });
  };

  setSelectSkipCount = (value: number) => {
    runInAction(() => {
      this.selectSkipCount = value;
    });
  };

  setSelectScroll = (value: boolean) => {
    runInAction(() => {
      this.selectScroll = value;
    });
  };
}

export default ServiceGroupStore;
